export const ID_SANCOR = 10;

// A diferencia de Mercantil, no se encontraron condiciones propias de Sancor
// forzadas/validadas en el backend (esCamion, tipoPersona, tipoUso se pasan
// tal cual a la API) — no hay ninguna regla de negocio conocida para evaluar
// antes de cotizar. Solo se cubre la card gris para array vacío y error de API.
export const evaluadorSancor = {
   usaCardGris: true,
   mensajeArrayVacio:
      'Sancor Seguros no tiene cotizaciones disponibles para los datos ingresados.',
   mensajeErrorApi:
      'Sancor Seguros no tiene cotizaciones disponibles para el vehículo o los datos ingresados. Probá con otra cobertura o consultá con tu asesor comercial.',
};
